import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var feedbackQuestionRes;
export const feedbackQuestionTodo = createAsyncThunk('feedbackQuestion', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'feedback/view_feedback_question',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return feedbackQuestionRes = res.data
    } catch (error) {
        return feedbackQuestionRes = error.response.data
    }
})


const feedbackQuestionSlice = createSlice({
    name: 'feedbackQuestion',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(feedbackQuestionTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('feedbackQuestion', state.data)
            }
        });
        builder.addCase(feedbackQuestionTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default feedbackQuestionSlice.reducer; 